import * as PropTypes from 'prop-types';
import QRCodeStyling from 'qr-code-styling';
import React, { useEffect, useRef } from 'react';
import './QRGenerate.scss';

const QRGenerate = ({ data, logo, size = 224 }) => {
	const qrRef = useRef(null);
	const qr = useRef(null);

	useEffect(() => {
		if (qrRef.current.childNodes.length > 0) return;

		qr.current = new QRCodeStyling({
			width: size,
			height: size,
			data,
			image: logo,
			dotsOptions: {
				type: 'dots',
				color: '#000',
			},
			cornersSquareOptions: {
				type: 'extra-rounded',
			},
			cornersDotOptions: {
				type: 'extra-rounded',
			},
			backgroundOptions: {
				color: '#fff',
			},
		});

		qr.current.append(qrRef.current);

		return () => {
			qr.current = null;
		};
	}, []);

	return <div ref={qrRef}></div>;
};

QRGenerate.propTypes = {
	data: PropTypes.string,
	logo: PropTypes.string,
	size: PropTypes.number,
};

export default QRGenerate;
